import { Component, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { UtilsService } from "../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CandidateService } from "../../../modules/recruitment/candidates/candidate.service";
import { CollaboratorsService } from "../../../modules/collaborators/collaborators.service";

@Component({
  selector: "app-sign-contract",
  templateUrl: "./sign-contract.component.html",
  styleUrls: ["./sign-contract.component.scss"],
})
export class SignContractComponent implements OnInit {
  public signed_contract: any;
  public currentUser: any;
  private user_hash: any;
  public sended: boolean = false;
  private isACollaborator: boolean = false;

  /**
   * Constructor
   * @param {UtilsService} _utilService
   * @param {CoreConfigService} _coreConfigService
   * @param _router
   * @param _activatedRoute
   * @param _candidateService
   * @param _collaboratorService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    public _utilService: UtilsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _candidateService: CandidateService,
    private _collaboratorService: CollaboratorsService,
  ) {
    this._utilService.disableAutoHideLoading();
    //Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };

    this._activatedRoute.queryParams.subscribe((params) => {
      if (params.token && params.u) {
        localStorage.clear();
        localStorage.setItem("token", params.token);
        localStorage.setItem("type", params.type);
        localStorage.setItem("candidate", params.u);
        this._router.navigateByUrl(window.location.pathname);
      }
    });
  }

  async ngOnInit() {
    this.user_hash = localStorage.getItem("candidate");
    const type: string = localStorage.getItem("type");
    if (this.user_hash) {
      if (type === "candidate") {
        this.currentUser = await this._candidateService.getCandidate(this.user_hash);
      } else {
        this.currentUser = await this._collaboratorService.getCollaborator(this.user_hash);
        this.isACollaborator = true;
      }
      if (!this.currentUser) {
        await this._router.navigateByUrl("/");
      }
    }
    this._utilService.hideLoading();
  }

  handlerChangeFileInput(event: any, what: string) {
    const extensionPermitted = ["pdf", "jpg", "jpeg"];
    const file = event.target.files[0].name;
    const extension = file.split(".").pop().toLowerCase();

    if (extensionPermitted.includes(extension)) {
      this._utilService.convertFileToBase64(event, async (e: any) => {
        const r = e.target.result;
        switch (what) {
          case "signed_contract":
            this.signed_contract = r;
            break;
        }
        this._utilService.showLoading();
        if (this.signed_contract) {
          await this._utilService
            .basic_post(!this.isACollaborator ? `/candidate/${this.user_hash}/upload-signed-contract` : `/collaborator/${this.user_hash}/upload-signed-contract`, { file: this.signed_contract })
            .then(async () => {
              this.sended = true;
              localStorage.clear();
              await this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FILE_DOCUMENT" });
            })
            .catch(async () => {
              await this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE_DOCUMENT" });
            });
        }
      });
    } else {
      this._utilService.showSWALError({ text: "INVALID_FORMAT" });
      event.target.value = null;
    }
  }

  async download() {
    this._utilService.showLoading();
    try {
      const getContract: any = await this._utilService.basic_get(!this.isACollaborator ? `/candidate/${this.user_hash}/contract` : `/collaborator/${this.user_hash}/contract`);
      const contractFileName: string = await this._utilService.translate("YOUR_CONTRACT").then((str: string) => str.replace("USER_LASTNAME", this.currentUser.lastname));
      await this._utilService.downloadPDF(getContract.contract, contractFileName);
      this._utilService.hideLoading();
    } catch (e: any) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ message: "ERROR_DONWLOAD_FILE" });
    }
  }
}
